import React, { Component } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { dateHelper } from "../helpers";

class DateFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterName: props.filterName,
      displayName: props.displayName,
      value: props.value,
      onChangeCallback: props.onChangeCallback
    };

    this.onChange = this.onChange.bind(this);
  }

  onChange(value) {
    const dateDisplay = value
      ? `${this.state.displayName}: ${dateHelper.getSelectedDate(value, "MM/DD/YYYY")}`
      : null;

    this.state.onChangeCallback({
      value: value,
      filterName: this.state.filterName,
      filteredDisplay: dateDisplay
    });
  }

  render() {
    return (
      <div>
        <div
          className={
            this.props.customFilterClassName
              ? this.props.customFilterClassName
              : "filterCaption"
          }
        >
          {this.state.displayName}
        </div>
        <DatePicker
          selected={this.props.value}
          onChange={this.onChange}
          className="form-control"
        />
      </div>
    );
  }
}

export default DateFilter;



// WEBPACK FOOTER //
// ./src/components/DateFilter.js